import { create } from 'zustand'
import type { ConnState } from '@/ha/types'

interface ConnectionStore extends ConnState {
  set: (s: ConnState) => void
}

export const useConnectionStore = create<ConnectionStore>((set) => ({
  phase: 'idle',
  lastPongAt: null,
  lastError: null,
  set: (s) => set(s),
}))
